// Plugin para renderizar underline con sintaxis __texto__
// En markdown estándar __ es para emphasis fuerte (bold), pero aquí lo usamos para underline
// ya que es la convención que usa Typebot

const underlinePlugin = md => {
  // Modificar el procesamiento de emphasis para diferenciar __ de **
  md.inline.ruler2.after('emphasis', 'underline', state => {
    const tokens = state.tokens;

    for (let idx = 0; idx < tokens.length; idx += 1) {
      const token = tokens[idx];

      // Buscar tokens strong_open que usen __
      if (token.type !== 'strong_open') {
        // eslint-disable-next-line no-continue
        continue;
      }

      // Verificar si el markup es __ (underline) en lugar de ** (bold)
      if (token.markup === '__') {
        token.tag = 'u';
        token.type = 'underline_open';

        // Buscar el token de cierre correspondiente
        for (let j = idx + 1; j < tokens.length; j += 1) {
          if (tokens[j].type === 'strong_close' && tokens[j].markup === '__') {
            tokens[j].tag = 'u';
            tokens[j].type = 'underline_close';
            break;
          }
        }
      }
    }

    return false;
  });

  // Renderizar los tokens de underline como <u>
  md.renderer.rules.underline_open = () => '<u>';
  md.renderer.rules.underline_close = () => '</u>';
};

export default underlinePlugin;
